import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { cryptoWalletsKeys } from '../cryptoWalletsQueryKeys'
import { getVaspWalletDetails } from '../vaspWalletEndpoints'

export function useVaspWalletDetailsQuery(id: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: () => cryptoWalletsKeys.vaspWalletDetail(toValue(id)),
    queryFn: () => getVaspWalletDetails(toValue(id)),
    enabled: () => Boolean(toValue(id)),
  })
}
